import React__default from 'react';
import useKeyPress from './use-key-press.js';

const useCursor = ({ hasTopContent , onSubmit , onSuggestionClick , onSuggestionTopContentClick , ref , setIsSuggestionsOpen , suggestions  })=>{
    const startCursorValue = 0;
    const [cursor, setCursor] = React__default.useState(-1);
    const [hovered, setHovered] = React__default.useState(undefined);
    const downPress = useKeyPress('ArrowDown', ref);
    const upPress = useKeyPress('ArrowUp', ref);
    const enterPress = useKeyPress('Enter', ref);
    const spacePress = useKeyPress('Space', ref);
    React__default.useEffect(()=>{
        if (!upPress) {
            return;
        }
        if (cursor < 0) {
            setCursor(suggestions.length);
            return;
        }
        setCursor((prevState)=>{
            if (prevState > startCursorValue) {
                return prevState - 1;
            } else {
                setIsSuggestionsOpen(false);
                return -1;
            }
        });
    }, [
        upPress
    ]);
    React__default.useEffect(()=>{
        if (!downPress) {
            return;
        }
        if (cursor < 0) {
            setCursor(startCursorValue);
            return;
        }
        setCursor((prevState)=>{
            const numberOfSuggestions = hasTopContent ? suggestions.length : suggestions.length - 1;
            if (prevState < numberOfSuggestions) {
                return prevState + 1;
            } else {
                setIsSuggestionsOpen(false);
                return -1;
            }
        });
    }, [
        downPress
    ]);
    React__default.useEffect(()=>{
        if (enterPress && cursor === -1 && typeof onSubmit === 'function') {
            onSubmit();
            return;
        }
        if (enterPress && cursor === startCursorValue && typeof onSuggestionTopContentClick === 'function') {
            onSuggestionTopContentClick();
            return;
        }
        const item = hasTopContent ? suggestions[cursor - 1] : suggestions[cursor];
        if (enterPress && suggestions.length && item) {
            onSuggestionClick(item.id);
        }
    }, [
        enterPress
    ]);
    React__default.useEffect(()=>{
        if (spacePress && cursor === startCursorValue && typeof onSuggestionTopContentClick === 'function') {
            onSuggestionTopContentClick();
            return;
        }
        const item = hasTopContent ? suggestions[cursor - 1] : suggestions[cursor];
        if (spacePress && suggestions.length && item) {
            onSuggestionClick(item.id);
        }
    }, [
        spacePress
    ]);
    React__default.useEffect(()=>{
        if (hovered === 'content') {
            setCursor(0);
            return;
        }
        if (hovered === undefined) {
            setCursor(-1);
        }
        if (suggestions.length && hovered) {
            const index = hasTopContent ? 1 : 0;
            setCursor(suggestions.indexOf(hovered) + index);
        }
    }, [
        hovered
    ]);
    React__default.useEffect(()=>{
        setCursor(-1);
    }, [
        suggestions
    ]);
    return React__default.useMemo(()=>({
            cursor,
            setCursor,
            setHovered
        })
    , [
        cursor,
        setCursor,
        setHovered
    ]);
};
var useCursor$1 = useCursor;

export { useCursor$1 as default };
//# sourceMappingURL=use-cursor.js.map
